module.exports = __webpack_public_path__ + "static/img/content.77d3231.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/glassesgallery/content.jpg
// module id = 5FwO
// module chunks = 1